import accountSettingsUrls from '../../../../urls/accountSettingsUrls';
import Vue from 'vue';

const state = {

  accountSettings: null

}

const getters = {

  accountSettings(state) {
    return state.accountSettings;
  }

}

const mutations = {

}

const actions = {

  getAccountSettings(context, payload) {

    return new Promise((resolve, reject) => {

      Vue.$http.post(accountSettingsUrls.getAccountSettings, payload).then((response) => {

        context.state.accountSettings = response.data;
        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });

  },

  saveAccountSettings(context, payload) {

    return new Promise((resolve, reject) => {

      Vue.$http.post(accountSettingsUrls.saveAccountSettings, payload).then((response) => {

        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });

  },

  savePassword(context, payload) {

    return new Promise((resolve, reject) => {

      Vue.$http.post(accountSettingsUrls.savePassword, payload).then((response) => {

        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });

  }

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/Account/AccountSettings/store/accountSettings.js